import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Multiselect from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
// @mui  
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
import * as incidentReporteActions from "../../actions/incidentReporteActions";

import AccessDenied from '../common/AccessDenied';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const LeadFlowReport = (props) => {
  const { actions, leadsData, usersData, sourceData, getUserModuleData, masterProfileData, leadStatusData } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  //   const [allLeads, setAllLeads] = useState([]);


  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [showLeadDetails, setShowLeadDetails] = useState(false);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [getSelectedLeadStatus, setSelectedLeadStatus] = useState([]);
  const [getSelectedLeadProfile, setSelectedLeadProfile] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  //   const [allLeadSource, setAllLeadSource] = useState([]);


  const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);
  //   const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [legalFormId, setLegalFormId] = useState('person');

  const [userRoleType, setUserRoleType] = useState('');
  const [loggeInUserID, setLoggeInUserID] = useState('');

  const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [viewUPIModulePermissionStatus, setViewUPIModulePermissionStatus] = useState(false);
  const [isCamChecked, setIsCamChecked] = useState(false);
  const [allLeadFlow, setAllLeadFlow] = useState([]);
  const [totalRowsLead, setTotalRowsLead] = useState(0);
  const [pageSizeLeadPage, setPageSizeLeadPage] = useState(config.ITEMS_PER_PAGE);
  const [currentPageLeadPage, setCurrentPageLeadPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [allLeadFlowExcel, setAllLeadFlowExcel] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [keyword, setKeyword] = useState('');
  const [debitDate1, setDebitDate1] = useState('');
  const [emiAmount1, setEmiAmount1] = useState('');
  const [excelFileBtnHide, setExcelFileBtnHide] = useState(false);
  const [noOfLeadsEntered, setNoOfLeadsEntered] = useState(0);
  const [noOfBureauPulled, setNoOfBureauPulled] = useState(0);
  const [noOfAadharOtpDone, setNoOfAadharOtpDone] = useState(0);
  const [noOfBankStatementUploaded, setNoOfBankStatementUploaded] = useState(0);
  const [noOfFIDraftDone, setNoOfFIDraftDone] = useState(0);
  const [noOfFICompletedDone, setNoOfFICompletedDone] = useState(0);
  const [noOfSendToCredit, setNoOfSendToCredit] = useState(0);

  const [noOfCamSubmitted, setNoOfCamSubmitted] = useState(0);
  const [noOfCamApproved, setNoOfCamApproved] = useState(0);
  const [noOfCamRejected, setNoOfCamRejected] = useState(0);

  
  
  
  
  
  const [filters, setFilters] = useState({
    username: '',
    start_date: '',
    end_date: '',
    cam_stage: ''
  });


  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const roleName = localStorage.getItem('authUserRoleName');
    if (roleName !== null) {
      setUserRoleType(roleName);
    }
    const response = actions.getUserModuleData(requestData);
    response.then((result) => {
      if (result.data.success === 1) {
        const permissionsData = result.data.data;
        const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Leads')?.view_permission;
        setPermissions(permissionsData);
        setViewModulePermissionStatus(hasViewPermissions);
        setUserHasPermission(hasViewPermissions);

        if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
          setUserRoleType(result.data.user_info[0].role_type);
          // alert(result.data.user_info[0].role_type);
          setLoggeInUserID(result.data.user_info[0].user_id);

          if (result.data.user_info[0].role_type.toLowerCase() === "credit head") {
            setIsCamChecked(true);
          }

        }

        if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'is_external_user') && result.data.user_info[0].is_external_user !== '' && result.data.user_info[0].is_external_user === "1") {
          setIsExternalUser(true);
        }

        const hasViewUPIPermissions = permissionsData.find(permission => permission.module_name === 'UPI Registration')?.view_permission;
        setViewUPIModulePermissionStatus(hasViewUPIPermissions);
      }
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });
  }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID, setIsExternalUser]);


  const getOtherDetails = (requestData) => {
    setNoOfLeadsEntered(0);
    setNoOfBureauPulled(0);
    setNoOfAadharOtpDone(0);
    setNoOfBankStatementUploaded(0);
    setNoOfFIDraftDone(0);
    setNoOfFICompletedDone(0);
    setNoOfSendToCredit(0);

    setNoOfCamSubmitted(0);
    setNoOfCamApproved(0);
    setNoOfCamRejected(0); 

 
    const response = actions.leadFlowOtherDetails(requestData, true);
  
      response.then((result) => {
          
        if (result?.data?.other_details?.no_of_leads_entered) { 
          setNoOfLeadsEntered(result.data.other_details.no_of_leads_entered);
          } 
          
          if (result?.data?.other_details?.no_of_bureau_pulled) { 
            setNoOfBureauPulled(result.data.other_details.no_of_bureau_pulled);
            } 

            if (result?.data?.other_details?.no_of_aadhar_otp_done) { 
              setNoOfAadharOtpDone(result.data.other_details.no_of_aadhar_otp_done);
              } 
              if (result?.data?.other_details?.no_of_bank_statement_uploaded) { 
                setNoOfBankStatementUploaded(result.data.other_details.no_of_bank_statement_uploaded);
                }
          if (result?.data?.other_details?.no_of_fi_draft_done) { 
            setNoOfFIDraftDone(result.data.other_details.no_of_fi_draft_done);
          } 
          if (result?.data?.other_details?.no_of_fi_completed_done) { 
            setNoOfFICompletedDone(result.data.other_details.no_of_fi_completed_done);
          }
          if (result?.data?.other_details?.no_of_send_to_credit) { 
            setNoOfSendToCredit(result.data.other_details.no_of_send_to_credit);
          }
          
          if (result?.data?.other_details?.no_of_cam_submitted) { 
            setNoOfCamSubmitted(result.data.other_details.no_of_cam_submitted);
          }  

          if (result?.data?.other_details?.no_of_cam_approved) { 
            setNoOfCamApproved(result.data.other_details.no_of_cam_approved);
          } 

          if (result?.data?.other_details?.no_of_cam_rejected) { 
            setNoOfCamRejected(result.data.other_details.no_of_cam_rejected);
          } 
          
              
      }).catch((error) => {
        console.error("Promise rejected - lead list:", error);
      });
  }

  const onSubmit = () => {
    setLoading(true);
    const params = {
      size: pageSizeLeadPage,
      offsetPage: currentPageLeadPage,
      username: filters.username,
      start_date: filters.start_date,
      end_date: filters.end_date,
      cam_stage: filters.cam_stage
    };
    
    const requestData = encryptData(params);
    const response = actions.leadFlowReport(requestData, true);
  
    response.then((result) => {
        if (!result.data.data || result.data.data === '') {
        setExcelFileBtnHide(true);
      } else {
        setExcelFileBtnHide(false);
      }
      setAllLeadFlow(result.data.data);
      setTotalRowsLead(result.data.total_count);
      getOtherDetails(requestData);
    }).catch((error) => {
      console.error("Promise rejected - lead list:", error);
    });
  };
  
  const handleFilterChange = (data) => {
    setFilters({
      username: data?.username,
      start_date: data?.start_date,
      end_date: data?.end_date,
      cam_stage: data?.cam_stage
    });
    setCurrentPageLeadPage(1);
  };
  
  useEffect(() => {
    onSubmit();
  }, [filters, currentPageLeadPage, pageSizeLeadPage]);
  
  const handlePerRowsChangeLeadPage = (newPageSizeLeadPage, currentPageLeadPage) => {
    setPageSizeLeadPage(newPageSizeLeadPage);
    setCurrentPageLeadPage(currentPageLeadPage);
  };
  
  const handlePageChangeLeadPage = (page) => {
    setCurrentPageLeadPage(page);
  };

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    const formattedThreeMonthsAgo = threeMonthsAgo.toISOString().split('T')[0];

    setValue('start_date', formattedThreeMonthsAgo);
    setValue('end_date', formattedToday);

    let userRoleTypeVal = userRoleType;
    let isCamCheckedVal = isCamChecked;
    const roleName = localStorage.getItem('authUserRoleName');

    if (roleName !== null) {
      setUserRoleType(roleName);
      userRoleTypeVal = roleName;
      if (roleName.toLowerCase() === "credit head") {
        setIsCamChecked(true);
        isCamCheckedVal = true;
      }
    }

    setShowLeadDetails(false);
    if (!showLeadDetails) {
      const obj = {
        // "user_role_type": userRoleTypeVal ,
        "size": pageSizeLeadPage,
        "offsetPage": currentPageLeadPage,
      };
      const requestData = encryptData(obj);
      const response = actions.leadFlowReport(requestData);
      response.then((result) => {
        const results = result.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        setAllLeadFlow(resultArr);
        setTotalRowsLead(result.data.total_count);
        setLoading(false)
        getOtherDetails(requestData);
      })
    }

    if (Array.isArray(usersData.data)) {
      const extractedData = usersData.data.map(item => {
        return { id: item.user_id, name: item.name };
      });
      const resultArr = Object.values(extractedData);
      setAllUsers(resultArr);
    }

    const objSource = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestSourceData = encryptData(objSource);
    const responseSource = actions.sourceData(requestSourceData, false);
    responseSource.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data
        const filteredResultArr = results.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.source_of_lead.localeCompare(b.source_of_lead)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.source_of_lead };
        });
        const resultArr = Object.values(extractedData);
      }
    }).catch((error) => {
    });

    const objMasterProfile = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestDataMasterProfile = encryptData(objMasterProfile);
    const responseMasterProfile = actions.masterProfileData(requestDataMasterProfile, false);
    responseMasterProfile.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        const filteredResultArr = resultArr.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.lead_profile_name.localeCompare(b.lead_profile_name)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.lead_profile_name };
        });
        const extractedObject = Object.values(extractedData);
        setAllMasterProfiles(extractedObject);
      }
    }).catch((error) => {
    });

    const objLeadStatus = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestLeadStatusData = encryptData(objLeadStatus);
    const leadStatusResponse = actions.leadStatusData(requestLeadStatusData);
    leadStatusResponse.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        const filteredResultArr = resultArr.filter((item) => item.status === "1");
        const sortedResultArr = filteredResultArr.sort((a, b) =>
          a.lead_status.localeCompare(b.lead_status)
        );
        const extractedData = sortedResultArr.map(item => {
          return { id: item.id, name: item.lead_status };
        });
        const extractedObject = Object.values(extractedData);
      }
    }).catch((error) => {
    });
  }, [setAllUsers, setAllMasterProfiles]);

  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getLoggedinUserChild(requestData, false);
    response.then((result) => {
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const extractedData = results.map(item => {
          return { id: item.user_id, name: item.name };
        });
        const resultArr = Object.values(extractedData);
        setAllLoggedinUserChild(resultArr);
      }
    }).catch((error) => { 
    });
  }, [setAllLoggedinUserChild]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const checkLogout = () => {
    const authToken = localStorage.getItem('authToken');
    const logInTimestamp = localStorage.getItem('logInTimestamp');

    if (logInTimestamp !== null) {
      const loginTimestamp = parseInt(logInTimestamp, 10);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeElapsed = currentTime - loginTimestamp;
      const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

      if (timeElapsed >= autoLogoutTimeInSecod) {
        const params = { 'login_token': authToken };
        console.log("params : ", params);
        const requestData = encryptData(params);
        const response = actions.userLogout(requestData);
        response.then((result) => {
          if (result.data.success === 1) {
            const data = {};
            actions.loadUserAuth(false);
            actions.loginDataSuccess(data);
            localStorage.setItem("authToken", '');
            localStorage.setItem("logInTimestamp", '');
            navigate("/login");
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }
  }

  const exportToExcel = () => {
    const totalCount = totalRowsLead;
    if (totalCount > 0) {
      const allDataParams = {
        "size": totalCount,
        "offsetPage": 1,
      };
      const requestData = encryptData(allDataParams);
      const response = actions.leadFlowReport(requestData);
      response.then((result) => {
        if (result.data && result.data.success === 1 && result.data.data) {
          const results = result.data.data;
          if (results && typeof results === 'object') {
            const resultArr = Object.keys(results).map((key) => results[key]);
            const columnNameMapping = {
              lead_id: 'Lead Id',
              applicant_name: 'Applicant Name',
              applicant_number: 'Applicant Number',
              lead_assigned: 'Sales Person Name',
              applicant_aadhar_otp_verified: 'Applicant Aadhar OTP Verified',
              co_applicant_aadhar_otp_verified: 'Co-Applicant Aadhar OTP Verified',
              guarantor_aadhar_otp_verified: 'Guarantor Aadhar OTP Verified',
              bank_statement_upload: 'Bank Statement Upload',
              fi_draft_done: 'FI Draft Done',
              fi_complete_done: 'FI Complete Done',
              cam_complete: 'CAM Complete',
              cam_approved_or_rejected: 'CAM Approved or Rejected',
            };
            const mappedData = resultArr.map((row) => {
              const mappedRow = {};
              Object.keys(row).forEach((key) => {
                if (key !== 'lead_id' && key !== 'total_count') {
                  const displayName = columnNameMapping[key] || key;
                  mappedRow[displayName] = row[key];
                }
              });
              return mappedRow;
            });
            const ws = XLSX.utils.json_to_sheet(mappedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Lead Flow Report');
            XLSX.writeFile(wb, 'LeadFlowReport.xlsx');
          } else {
            console.error("Invalid or empty results object", results);
          }
        } else {
          console.error("No data available for export or response error");
        }
        getOtherDetails(requestData);
      }).catch((error) => {
        console.error("Error fetching all data for export", error);
      });
    } else {
      console.error("Total count is not available or is 0");
    }
  };

  const allTableHead = [
    {
      name: 'S. No.',
      selector: (row, index) => {
        const safeCurrentPage = Number.isInteger(currentPageLeadPage) ? currentPageLeadPage : 1;
        const safeItemsPerPage = Number.isInteger(pageSizeLeadPage) ? pageSizeLeadPage : 10;
        const rowIndex = (safeCurrentPage - 1) * safeItemsPerPage + index + 1;
        return rowIndex;
      },
      sortable: false,
      width: '70px',  
      style: {
        textAlign: 'center',  
      },
    },
    {
      name: 'Applicant Name',
      selector: (row) => row?.applicant_name || '-',
      sortable: true,
    },
    {
      name: 'Applicant Number',
      selector: (row) => row?.applicant_number || '-',
      sortable: true,
      cell: row => (
        <a 
            href={`/dashboard/edit-lead/${btoa(row.lead_id)}`} 
            style={{ textDecoration: 'none', color: 'blue' }} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            {row.applicant_number}
        </a>
    ),
    },
    {
      name: 'Sales Persone Name',
      selector: (row) => row?.lead_assigned || '-',
      sortable: true,
    },
    {
      name: 'Applicant Aadhar OTP Verfified',
      selector: (row) => row?.applicant_aadhar_otp_verified || '-',
      sortable: true,
    },
    {
      name: 'Co-Applicant Aadhar OTP Verfified',
      selector: (row) => row?.co_applicant_aadhar_otp_verified || '-',
      sortable: true,
    },
    {
      name: 'Guarantor Aadhar OTP Verfified',
      selector: (row) => row?.guarantor_aadhar_otp_verified || '-',
      sortable: true,
    },
    {
      name: 'Bank Statement Upload',
      selector: (row) => row?.bank_statement_upload || '-',
      sortable: true,
    },
    {
      name: 'FI Draft Done',
      selector: (row) => row?.fi_draft_done || '-',
      sortable: true,
    },
    {
      name: 'FI Complete Done',
      selector: (row) => row?.fi_complete_done || '-',
      sortable: true,
    },
    {
      name: 'CAM Complete',
      selector: (row) => row?.cam_complete || '-',
      sortable: true,
    },
    {
      name: 'CAM Approved or Rejected',
      selector: (row) => row?.cam_approved_or_rejected || '-',
      sortable: true,
    },

  ];

  return (
    <>
      <Helmet>
        <title> Lead Flow Report </title>
      </Helmet>
      <div id='main-wrap' className='mb-4 ms-4 me-4'>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Lead Flow Report
        </Typography>
        <form onSubmit={handleSubmit(handleFilterChange)}>
          <div id='main-wrap' className='mb-3 filter'>
            <div className='row mx-0'>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Username</span>
                    <input type='text' name='username' className='form-control' {...register('username')} />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="start-date">
                    <span>Start Date</span>
                    <input type='date' name='start_date' className='form-control' {...register('start_date')} />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="end-date">
                    <span>End Date</span>
                    <input type='date' name='end_date' className='form-control' {...register('end_date')} />
                  </label>
                </div>
              </div>

              <div className='col'>
                <div className='form-group'>
                  <label htmlFor="cam_stage">
                    <span>Stage</span>
                    <select id="cam_stage" className="form-select" {...register("cam_stage")} >
                      <option value="">Select</option>
                      <option value="0">Send to Credit Head</option>
                      <option value="1">Approved</option>
                      <option value="2">Rejected</option>
                      <option value="sent_to_credit">Sent to Credit</option>
                      <option value="aadhar_verify">Aadhar Verified</option>
                      <option value="fi_done">FI Done</option>
                      <option value="bank_statement_upload">Bank Statement Upload</option>
                    </select>
                  </label>
                </div>
              </div>
              <div className='col'>
                <div className='form-group mb-2'>
                  <span className='d-block'>&nbsp;</span>
                  <button className='btn btn-primary'>Search</button>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div className="row mx-0">
           
            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
            <div>
              <h5 className="text-lg font-semibold">No Of Leads Entered</h5>
              <p className="text-2xl font-bold">{noOfLeadsEntered}</p>
            </div>
          </div>

          <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
            <div>
              <h5 className="text-lg font-semibold">No Of Bureau Pulled</h5>
              <p className="text-2xl font-bold">{noOfBureauPulled}</p>
            </div>
          </div>

          <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
            <div>
              <h5 className="text-lg font-semibold">No Of Aadhar OTP Done</h5>
              <p className="text-2xl font-bold">{noOfAadharOtpDone}</p>
            </div>
          </div>

          
         

          </div>
          
          <div className="row mx-0 mt-2">

            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
              <div>
                <h5 className="text-lg font-semibold">FI Draft Done</h5>
                <p className="text-2xl font-bold">{noOfFIDraftDone}</p>
              </div>
            </div> 

            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
              <div>
                <h5 className="text-lg font-semibold">FI Completed Done</h5>
                <p className="text-2xl font-bold">{noOfFICompletedDone}</p>
              </div>
            </div>

            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
              <div>
                <h5 className="text-lg font-semibold">Send To Credit</h5>
                <p className="text-2xl font-bold">{noOfSendToCredit}</p>
              </div>
            </div>

      </div>


      <div className="row mx-0 mt-2">

          <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
            <div>
              <h5 className="text-lg font-semibold">No Of Cam Submitted</h5>
              <p className="text-2xl font-bold">{noOfCamSubmitted}</p>
            </div>
          </div> 

          <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
            <div>
              <h5 className="text-lg font-semibold">No Of Cam Approved</h5>
              <p className="text-2xl font-bold">{noOfCamApproved}</p>
            </div>
          </div>

          <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
            <div>
              <h5 className="text-lg font-semibold">No Of Cam Rejected</h5>
              <p className="text-2xl font-bold">{noOfCamRejected}</p>
            </div>
          </div>

          </div> 
          <div className="row mx-0 mt-2">
            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
              <div>
                <h5 className="text-lg font-semibold">Bank Statements Uploaded</h5>
                <p className="text-2xl font-bold">{noOfBankStatementUploaded}</p>
              </div>
            </div>

            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
              &nbsp;
            </div>
            <div className="col bg-white shadow-lg rounded-2xl p-4 flex items-center space-x-4 m-2"> 
              &nbsp;
            </div>


          </div> 
        
      </div>

      <Container>
        <div id='main-wrap' className='mb-4'>
          {!excelFileBtnHide ? (
          <div className="col-md-12" style={{ display: 'flex', justifyContent: 'end' }}>
            <div className="col-md-6 text-end" style={{ marginRight: '1rem' }}>
              <div className="form-group mt-2">
                <button className="btn btn-info text-white" onClick={() => exportToExcel()}>Export Excel File</button>
              </div>
            </div>
          </div>
          ) : (
            <p>-</p>
          )}
          <div style={{ width: '100%', overflowY: 'auto' }}>
            <DataTable
              columns={allTableHead}
              data={allLeadFlow}
              pagination
              paginationServer
              paginationTotalRows={totalRowsLead}
              paginationPerPage={pageSizeLeadPage}
              paginationDefaultPage={currentPageLeadPage}
              onChangePage={handlePageChangeLeadPage}
              onChangeRowsPerPage={handlePerRowsChangeLeadPage}
            />
          </div>
        </div>
      </Container>
    </>
  );
}

function mapStateToProps(state) {
  return {
    // leadsData: state.leadsData,
    usersData: state.usersData,
    // sourceData: state.sourceData,
    getUserModuleData: state.getUserModuleData,
    masterProfileData: state.masterProfileData,
    // leadStatusData: state.leadStatusData,
    getLoggedinUserChild: state.getLoggedinUserChild,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default), dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadFlowReport);